import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock, FaDirections } from 'react-icons/fa';
import Seo from '../../components/Seo/Seo';
import ContactForm from '../../components/ContactForm/ContactForm';
import SouthBrisbaneMap from '../../components/SouthBrisbaneMap/SouthBrisbaneMap';

const Contact = () => {
  const contactInfo = [
    {
      icon: FaPhone,
      title: 'Phone',
      details: ['0466708090'],
      link: 'tel:0466708090',
    },
    {
      icon: FaEnvelope,
      title: 'Email',
      details: ['info@theskilledgroup.com'],
      link: 'mailto:info@theskilledgroup.com',
    },
    {
      icon: FaMapMarkerAlt,
      title: 'Service Area',
      details: ['Brisbane', 'QLD'],
      link: 'https://maps.google.com/?q=South+Brisbane+QLD',
    },
    {
      icon: FaClock,
      title: 'Business Hours',
      details: ['Open 24/7'],
      link: null,
    },
  ];

  return (
    <div>
      <Seo
        title="Contact The Skilled Group"
        description="Contact The Skilled Group for pest control, cleaning quotes, and service enquiries across Brisbane."
        canonicalPath="/contact"
      />
      {/* Page Header */}
      <div className="page-header">
        <div className="container-custom">
          <h1>Contact Us</h1>
          <p>
            Get in touch with The Skilled Group. We're here to help with all your
            cleaning needs.
          </p>
        </div>
      </div>

      {/* Contact Info Cards */}
      <section className="py-8 sm:py-12 lg:py-16 bg-gray-50">
        <div className="container-custom">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5 lg:gap-6">
            {contactInfo.map((info) => (
              <div
                key={info.title}
                className="bg-white rounded-xl p-4 sm:p-5 lg:p-6 border border-gray-100 text-center hover:shadow-md transition-shadow duration-300"
              >
                <div className="w-11 h-11 sm:w-12 sm:h-12 lg:w-14 lg:h-14 bg-primary-50 rounded-xl flex items-center justify-center mx-auto mb-3 sm:mb-4">
                  <info.icon className="text-lg sm:text-xl lg:text-2xl text-primary-500" />
                </div>
                <h3 className="text-base sm:text-lg font-heading font-semibold text-gray-800 mb-2 sm:mb-3">
                  {info.title}
                </h3>
                {info.details.map((detail) => (
                  <p key={detail} className="text-gray-500 text-xs sm:text-sm leading-relaxed">
                    {info.link ? (
                      <a
                        href={info.link}
                        className="hover:text-primary-500 transition-colors"
                        target={info.link.startsWith('http') ? '_blank' : '_self'}
                        rel={info.link.startsWith('http') ? 'noopener noreferrer' : undefined}
                      >
                        {detail}
                      </a>
                    ) : (
                      detail
                    )}
                  </p>
                ))}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form + Map */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
            {/* Form */}
            <div>
              <ContactForm />
            </div>

            {/* Map and info */}
            <div className="space-y-6">
              {/* Map */}
              <div className="overflow-hidden rounded-2xl border border-gray-200 shadow-sm">
                <SouthBrisbaneMap />
              </div>

              {/* Additional Info */}
              <div className="bg-primary-50 rounded-2xl p-6 md:p-8 border border-primary-100">
                <h3 className="text-lg font-heading font-semibold text-primary-500 mb-3">
                  Need Urgent Help?
                </h3>
                <p className="text-gray-600 text-sm mb-4">
                  For urgent cleaning requests, call our team and we will organise the
                  fastest available slot for your location.
                </p>
                <a
                  href="tel:0466708090"
                  className="btn-primary text-sm py-2.5 px-6 inline-flex items-center gap-2"
                >
                  <FaPhone />
                  Call Now: 0466708090
                </a>
              </div>

              {/* Service Area */}
              <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border border-gray-100">
                <h3 className="text-lg font-heading font-semibold text-gray-800 mb-3">
                  Service Areas
                </h3>
                <p className="text-gray-500 text-sm mb-4">
                  We serve suburbs across Brisbane. View the full service area list here.
                </p>
                <Link
                  to="/locations"
                  className="btn-primary text-sm py-2.5 px-6 inline-flex items-center gap-2"
                >
                  <FaDirections />
                  Go to Service Area Page
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;